import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import { Button, TextField, Card, Grid, CardHeader, CardContent, Typography, Box } from '@mui/material';
import { SelectField } from 'components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { enqueueSnackbar } from 'actions';
import { SetFormState, ToggleCreationBridgeCallDialog, CreateNewBridge, } from '../../../actions/BridgeCallActions';

const BridgeCallCreationDialog = (props) => {
	const { open, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.bridgeCallReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.bridgeCallReducer.formState);

	const _handleCreate = (event) => {
		dispatch(CreateNewBridge(userId));
		dispatch(ToggleCreationBridgeCallDialog(false));
	};

	const _handleClose = () => {
		dispatch(ToggleCreationBridgeCallDialog(false));
	};

	return (
		<div>
			<Dialog open={open} onClose={_handleClose}>
				<DialogTitle>Create New Bridge</DialogTitle>
				<DialogContent>
					<Grid>
						<Typography variant="h6">
							{`Are you sure you want to create a new Bridge?`}
						</Typography>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={_handleCreate}>Create</Button>
					<Button onClick={_handleClose}>Cancel</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

BridgeCallCreationDialog.propTypes = {
	open: PropTypes.bool
};

export default BridgeCallCreationDialog;
